/* Favorites / recently viewed / compare pages — device-local handles, live product data via section rendering. */
(function () {
  'use strict';
  if (window.__dstLists) return; window.__dstLists = true;
  function root() { var r = (window.DST && DST.config && DST.config.routes && DST.config.routes.root) || '/'; return r.replace(/\/$/, ''); }
  function fetchCard(handle, sectionId) {
    return fetch(root() + '/products/' + encodeURIComponent(handle) + '?section_id=' + sectionId, { credentials: 'same-origin' })
      .then(function (r) { if (r.status === 404) return null; if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) { if (!html) return null; return new DOMParser().parseFromString(html, 'text/html'); });
  }
  function load(sec) {
    var mode = sec.getAttribute('data-saved'), key = sec.getAttribute('data-key');
    var limit = Number(sec.getAttribute('data-limit')) || 12, exclude = sec.getAttribute('data-exclude');
    var list = (window.DST && DST.store ? DST.store.get(key) : []).filter(function (h) { return h && h !== exclude; }).slice(0, mode === 'compare' ? 3 : limit);
    var empty = sec.querySelector('[data-saved-empty]'), status = sec.querySelector('[data-saved-status]');
    if (!list.length) { if (mode === 'recent') { sec.hidden = true; return; } if (empty) empty.hidden = false; renderCompare(sec, []); var g0 = sec.querySelector('[data-saved-grid]'); if (g0) g0.innerHTML = ''; if (status) status.textContent = 'No saved products.'; return; }
    if (empty) empty.hidden = true;
    var sectionId = mode === 'compare' ? 'compare-fetch' : 'card-fetch';
    Promise.all(list.map(function (h) { return fetchCard(h, sectionId).catch(function () { return 'error'; }); })).then(function (docs) {
      var missing = [];
      if (mode === 'compare') {
        var cols = [];
        docs.forEach(function (d, i) { if (d === 'error') return; if (!d) { missing.push(list[i]); return; } var c = d.querySelector('[data-compare-col]'); if (c) cols.push(c); });
        renderCompare(sec, cols);
        if (!cols.length && empty) empty.hidden = false;
      } else {
        var grid = sec.querySelector('[data-saved-grid]'); grid.innerHTML = '';
        docs.forEach(function (d, i) {
          if (d === 'error') return;
          if (!d) { missing.push(list[i]); return; }
          var card = d.querySelector('[data-card-fetch] .card');
          if (card) { var li = document.createElement('li'); li.appendChild(document.importNode(card, true)); grid.appendChild(li); }
        });
        if (mode === 'recent') sec.hidden = !grid.children.length;
        else if (!grid.children.length && empty) empty.hidden = false;
      }
      // Products that no longer exist are dropped from the device list.
      missing.forEach(function (h) { DST.store.remove(key, h); });
      if (status) status.textContent = (mode === 'compare' ? 'Comparing ' : 'Showing ') + (list.length - missing.length) + ' products.';
      if (DST.syncListUI) DST.syncListUI();
    });
  }
  function renderCompare(sec, cols) {
    var body = sec.querySelector('[data-compare-body]'); if (!body) return;
    Array.prototype.forEach.call(body.querySelectorAll('tr'), function (tr) {
      while (tr.children.length > 1) tr.removeChild(tr.lastChild);
      var row = tr.getAttribute('data-row');
      cols.forEach(function (c) { var td = document.createElement('td'); var src = c.querySelector('[data-row="' + row + '"]'); td.innerHTML = src ? src.innerHTML : '—'; tr.appendChild(td); });
    });
  }
  function init() {
    var secs = document.querySelectorAll('[data-saved]');
    secs.forEach(load);
    document.addEventListener('click', function (e) {
      var c = e.target.closest('[data-saved-clear]');
      if (c) { var s = c.closest('[data-saved]'); DST.store.clear(s.getAttribute('data-key')); load(s); DST.announce('List cleared.'); }
      var r = e.target.closest('[data-compare-remove]');
      if (r) { DST.store.remove('dst_compare', r.getAttribute('data-handle')); document.querySelectorAll('[data-saved="compare"]').forEach(load); DST.announce('Removed from compare.'); }
    });
    document.addEventListener('dst:list', function (e) {
      var k = e.detail && e.detail.key;
      document.querySelectorAll('[data-saved]').forEach(function (s) { if (s.getAttribute('data-key') === k && s.getAttribute('data-saved') === 'wishlist') load(s); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
